import { render, staticRenderFns } from "./ChatAPI.vue?vue&type=template&id=10e94014&"
import script from "./ChatAPI.vue?vue&type=script&lang=js&"
export * from "./ChatAPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports